import(/* webpackMode: "eager" */ "/app/src/app/(default)/page.tsx")